const API_BASE_PROD = process.env.REACT_APP_API_BASE_PROD ?? '#{API_BASE_PROD}#';

const appEnv = {
  API_BASE_PROD,
};

export default appEnv;
